import { Component, OnInit } from "@angular/core"
import { Followup } from "@app/definitions/types"
import { FollowupsUpdateCommons } from "@app/followups-update-commons"
import { AvailablePostPaths } from "@app/services/api.service"

@Component({
	selector: "app-followups-for-supervisor-list",
	template: `
		<div class="row">
			<div class="col-12 col-lg-3">
				<app-gen-autocomplete
					#searchFuzzy
					title_ph_lang="patient"
					[fuzzySearchableClasses]="['patients']"
					(chosenEvent)="choosePatient($event)"
				>
				</app-gen-autocomplete>
			</div>
		</div>
		<table class="table table-striped table-hover">
			<thead>
				<tr>
					<th
						(click)="sort('patient_name')"
						sorter
						fieldName="patient_name"
						[displayName]="'patient_name' | langVal"
						[sortField]="sortField"
						[sortIsAsc]="sortIsAsc"
					></th>

					@if (permsService?.owner_has_users) {
						<th>{{ "locations" | langVal }}</th>
						<th>{{ "sub_users_therpaists" | langVal }}</th>
					}
					<th
						(click)="sort('date')"
						sorter
						fieldName="date"
						[displayName]="'date' | langVal"
						[sortField]="sortField"
						[sortIsAsc]="sortIsAsc"
					></th>
					@for (field of ["time", "arrived", "medical_record"]; track field) {
						<th>{{ field | langVal }}</th>
					}
				</tr>
			</thead>
			<tbody>
				@for (row of objectCollectionShown; track row) {
					@if (row.isNewDate) {
						<tr>
							<td
								colspan="99999"
								style="font-size: 18px"
							>
								{{ row.date | dateFormat }}
							</td>
						</tr>
					}
					<tr class="followups-list-tr">
						<td class="pointer link">
							<app-patient-modal [id]="row.patient_id">
								{{ row.patient_name }}
							</app-patient-modal>
						</td>
						@if (permsService?.owner_has_users) {
							<td>{{ row.location_name }}</td>
							<td>{{ row.assoc }}</td>
						}
						<td>{{ row.date | dateFormat }}</td>
						<td>{{ row.time | timeFormat }}</td>

						<td>
							@if (row.is_group == "no") {
								<app-yes-no [isCheck]="row.arrived == 'yes'" />
							}
						</td>
						<td>
							<span [innerHTML]="row.description | safeHtml"></span>
						</td>
					</tr>
					<tr>
						<td colspan="99">
							<label>{{ "supervisor_notes" | langVal }}:</label>
							<app-wysiwyg
								#descriptionWysiwyg
								[actualObj]="row"
								fieldName="supervisor_notes"
								[tabindex]="1"
								(changeEvent)="saveFollowup(row)"
							></app-wysiwyg>
						</td>
					</tr>
				}
			</tbody>
		</table>
	`,
})
export class FollowupsForSupervisorListComponent extends FollowupsUpdateCommons {
	apiFuncName: AvailablePostPaths = "get_followups_for_supervisor"

	saveFollowup(followup: Followup) {
		this.store.genSaveFollowup(followup)
	}
}
